import React, { lazy, Suspense } from 'react';

const Slider = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import('./index.lazy')), 1500);
  });
});

const SliderSuspense = (props) => (
  <Suspense>
    <Slider {...props} />
  </Suspense>
);

export default SliderSuspense;
